// src/contexts/SnackbarContext.tsx
import { Alert, Snackbar } from '@mui/material';
import { AlertColor } from '@mui/material/Alert';
import { createContext, useState } from 'react';

export const SnackbarContext = createContext({
  showSnackbar: (message: any, severity?: AlertColor) => {},
  hideSnackbar: () => {},
});

interface SnackbarState {
  open: boolean;
  message: string;
  severity: AlertColor;
}

export const SnackbarProvider = ({ children }: { children: React.ReactNode }) => {
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    message: '',
    severity: 'info',
  });

  const showSnackbar = (message: string, severity: AlertColor = 'info') => {
    setSnackbar({ open: true, message, severity });
  };

  const hideSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  return (
    <SnackbarContext.Provider value={{ showSnackbar, hideSnackbar }}>
      {children}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={hideSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left'}}
      >
        <Alert
          onClose={hideSnackbar}
          severity={snackbar.severity}
          sx={{
            color: '#fff', // ✅ white text
            backgroundColor:
              snackbar.severity === 'error'
                ? '#d32f2f' // darker red
                : snackbar.severity === 'success'
                ? '#2e7d32' // darker green
                : snackbar.severity === 'warning'
                ? '#ed6c02' // orange
                : '#0288d1', // info blue
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};
